import { bucketByDay, oldestFirst } from 'ui/Feed/groupByDay';

import { MemberGroupHistoryRow } from 'utils/api/modules/memberGroups';

export const batchSizeOf = (entry: MemberGroupHistoryRow): number => entry.batchSize ?? 1;

export const isBatched = (entry: MemberGroupHistoryRow): boolean => batchSizeOf(entry) > 1;

export const memberPreview = (entry: MemberGroupHistoryRow): (string | null)[] =>
  (entry.members ?? []).map((member) => member?.name ?? null);

export const groupHistoryByDay = (entries: MemberGroupHistoryRow[]): [string, MemberGroupHistoryRow[]][] =>
  bucketByDay(
    oldestFirst(entries, (entry) => entry.createdAt),
    (entry) => entry.createdAt
  );
